import { AccountDetails } from 'store/api/types';

export type AccountDetailsProps = {
  account: AccountDetails;
  openedModal: string | null;
  onSetOpenedModal: (type: string | null) => () => void;
  onSubmit: any;
};

export const ACCOUNT_NAME_MODAL = 'ACCOUNT-NAME';
export const COMPANY_DETAILS_MODAL = 'COMPANY-DETAILS';
export const CONTACT_INFORMATION_MODAL = 'CONTACT-INFORMATION';
export const REMOVE_MODAL = 'REMOVE-ACCOUNT';
